import { Result, Status } from "@chessalpha/core";
import { parseTimeControlString } from "./timeControlString.js";
export const undoInactiveTimeout = 600000; // 10min
export const autoStartExtraTime = 20000;
export const activityWalkOverTime = 60000;
export const defaultTimeControls = [
    "10+5",
    "10+0",
    "5+3",
    "5+0",
    "3+2",
    "3+0",
];
export const defaultTimeControl = parseTimeControlString(defaultTimeControls[0]);
export const defaultGame = {
    status: Status.CREATED,
    timeControl: {
        white: [defaultTimeControl],
        black: [defaultTimeControl],
    },
    createdBy: "bot_memdb",
    createdAt: Date.now(),
    updatedAt: Date.now(),
    white: { uid: "", name: "" },
    black: { uid: "", name: "" },
    result: Result.ONGOING,
};
export const defaultNodes = [
    {
        position: "start",
        start: true,
        timestamp: Date.now(),
        whiteTime: defaultTimeControl.limit,
        blackTime: defaultTimeControl.limit,
        next: [],
    },
];
//# sourceMappingURL=constants.js.map